import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { FaPlay, FaPause } from "react-icons/fa6";
import { colors, radius } from "../theme";
import AppIcon from "../AppIcon";

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 24px;
  box-sizing: border-box;
  background: linear-gradient(160deg, ${colors.lilac}, ${colors.sky});
`;

const Cover = styled.div<{ $spinning: boolean }>`
  width: 150px;
  height: 150px;
  border-radius: ${radius.pill};
  border: 3px solid ${colors.ink};
  background: repeating-radial-gradient(
    circle at center,
    #1d1d1f 0 6px,
    #2c2c30 6px 12px
  );
  position: relative;
  box-shadow: 5px 5px 0 rgba(29, 29, 31, 0.25);
  animation: spin 4s linear infinite;
  animation-play-state: ${({ $spinning }) => ($spinning ? "running" : "paused")};

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    margin: auto;
    width: 34px;
    height: 34px;
    border-radius: ${radius.pill};
    background: ${colors.green};
    border: 3px solid ${colors.ink};
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 17px;
  color: ${colors.ink};
`;

const Subtitle = styled.div`
  font-size: 13px;
  color: ${colors.inkSoft};
  margin-top: -10px;
`;

const PlayButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  border-radius: ${radius.pill};
  border: 3px solid ${colors.ink};
  background: #fff;
  cursor: pointer;
  box-shadow: 3px 3px 0 rgba(29, 29, 31, 0.25);
  transition: transform 0.12s ease;

  &:hover {
    transform: translate(-1px, -1px);
  }
  &:active {
    transform: translate(1px, 1px);
  }
`;

const MusicApp = () => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) {
      audio.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    } else {
      audio.pause();
      setPlaying(false);
    }
  };

  useEffect(() => {
    const audio = audioRef.current;
    return () => {
      if (audio) {
        audio.pause();
      }
    };
  }, []);

  return (
    <Wrap>
      <Cover $spinning={playing} />
      <Title>Now Playing</Title>
      <Subtitle>a little background tune</Subtitle>
      <PlayButton onClick={toggle} aria-label={playing ? "Pause" : "Play"}>
        <AppIcon icon={playing ? FaPause : FaPlay} size={22} />
      </PlayButton>
      <audio
        ref={audioRef}
        src="/music.mp3"
        loop
        onEnded={() => setPlaying(false)}
      />
    </Wrap>
  );
};

export default MusicApp;
